var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceInvestigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49.5938,
    r: 49,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.0013,
    cy: 49.5941,
    r: 40.8333,
    fill: "#FE4500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8511 57.932C54.1545 57.932 60.8857 51.3395 60.8857 43.2072C60.8857 35.0749 54.1545 28.4824 45.8511 28.4824C37.5476 28.4824 30.8164 35.0749 30.8164 43.2072C30.8164 51.3395 37.5476 57.932 45.8511 57.932Z",
    fill: "#42A2DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1479 70.9564C67.4513 70.9564 74.1826 64.3639 74.1826 56.2316C74.1826 48.0993 67.4513 41.5068 59.1479 41.5068C50.8445 41.5068 44.1133 48.0993 44.1133 56.2316C44.1133 64.3639 50.8445 70.9564 59.1479 70.9564Z",
    fill: "#0D5C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8846 43.2077C60.8846 51.3389 54.1537 57.931 45.8499 57.931C45.2934 57.931 44.7428 57.9019 44.2026 57.8436C44.143 57.3145 44.1133 56.7767 44.1133 56.2316C44.1133 48.099 50.8456 41.5068 59.1479 41.5068C59.7045 41.5068 60.2551 41.536 60.7953 41.5943C60.8548 42.1233 60.8846 42.6626 60.8846 43.2077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceInvestigationIcon);
export default __webpack_public_path__ + "static/media/ServiceInvestigationIcon.fa7ba4ecafe97571ed01d04ac22b6850.svg";
export { ForwardRef as ReactComponent };